<script setup lang="ts">
import { computed, onMounted } from 'vue';

import ProductRecommendations from '@/components/recommendations/ProductRecommendations.vue';
import { useDyChooseResults } from '@/composables/dynamic-yield/experiences';
import { RecommendationsChoice, RecommendationsSlot } from '@/lib/personalization/dynamicYield';
import { productSlotsFromChoice } from '@/utils/dynamic-yield/recommendationsRow';

const dySelector = '[RECOM] Auto Delivery - Row';
const { choicesByName, loadExperiences } = useDyChooseResults<RecommendationsChoice>(dySelector);
const choice = computed(() => choicesByName[dySelector]);
const recommendations = computed<RecommendationsSlot[]>(() => productSlotsFromChoice(choice.value));

onMounted(async () => {
  window.dataLayer.push({ GDR: { pagetype: 'autodelivery' } });
  await loadExperiences();
});
</script>

<template>
  <div class="w-full">
    <div>
      <div v-if="recommendations.length">
        <div class="container w-full">
          <ProductRecommendations
            :decisionId="choice?.decisionId"
            enableAddToCart
            :list="recommendations"
            spacingDirection="top"
            spacingLevel="md"
            title="Picks for You"
            trackingEventLocation="AUTODELIVERY"
          />
        </div>
      </div>
    </div>
  </div>
</template>
